import axios from 'axios';
import { headers, getBackOfficeRoute } from './header';
import { ROLE_RENTER } from '../../constants/roles';

const BooksApiService = {

  getBooks(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/books`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  deleteBook(token, bookID, role) {
    return axios
      .delete(`${getBackOfficeRoute(role)}/books/${bookID}`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  getBooksLld(token, role, limit, page, siteId) {
    let params = [];
    let stringParam = '';
    if (limit || page) {
      params.push(`limit=${limit}&page=${page}`);
    }
    if (siteId) {
      params.push(`siteId=${siteId}`);
    }
    if (params.length > 0) {
      stringParam = '?' + params.join('&');
    }
    return axios
      .get(`${getBackOfficeRoute(role)}/books/lld${stringParam}`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postBookStartInventory(token, bookId, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios
      .post(`${getBackOfficeRoute(ROLE_RENTER)}/books/${bookId}/start-inventory`, formData,{
        headers: {...headers(token), 'Content-Type': 'multipart/form-data'},
      })
      .then((response) => response.data);

  },

  deleteBookStartInventory(token, bookId) {
    return axios
      .delete(`${getBackOfficeRoute(ROLE_RENTER)}/books/${bookId}/start-inventory`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  }
};

export default BooksApiService;



// WEBPACK FOOTER //
// ./src/services/api/BooksApiService.js